import { createSlice } from "@reduxjs/toolkit";
import jwtDecode from "jwt-decode";

function verifyAdminToken() {
  const token = localStorage.getItem("admin-token");

  if (!token) {
    return null;
  }

  try {
    const decoded = jwtDecode(token);
    const expiresIn = new Date(decoded.exp * 1000);

    if (new Date() > expiresIn) {
      localStorage.removeItem("admin-token");
      return null;
    }

    return token;
  } catch {
    localStorage.removeItem("admin-token");
    return null;
  }
}

function parseUser() {
  const userData = localStorage.getItem("user");

  if (!userData) {
    return null;
  }

  try {
    return JSON.parse(userData);
  } catch {
    localStorage.removeItem("user");
    return null;
  }
}

const authReducer = createSlice({
  name: "authReducer",
  initialState: {
    adminToken: verifyAdminToken(),
    userToken: localStorage.getItem("userToken") || null,
    user: parseUser(),
  },
  reducers: {
    setAdminToken: (state, action) => {
      state.adminToken = action.payload;
      localStorage.setItem("admin-token", action.payload);
    },

    setUserToken: (state, action) => {
      const token = action.payload?.token || action.payload;
      const user = action.payload?.user || null;

      state.userToken = token;
      state.user = user;

      localStorage.setItem("userToken", token);

      if (user) {
        localStorage.setItem("user", JSON.stringify(user));
      } else {
        localStorage.removeItem("user");
      }
    },

    setUser: (state, action) => {
      state.user = action.payload || null;

      if (action.payload) {
        localStorage.setItem("user", JSON.stringify(action.payload));
      } else {
        localStorage.removeItem("user");
      }
    },

    logout: (state, { payload }) => {
      localStorage.removeItem(payload);

      if (payload === "admin-token") {
        state.adminToken = null;
      }

      if (payload === "userToken") {
        localStorage.removeItem("user");
        state.userToken = null;
        state.user = null;
      }
    },
  },
});

export const { setAdminToken, setUserToken, setUser, logout } = authReducer.actions;

export default authReducer.reducer;
